import { CATALOG_ONLY_CTA_LABEL } from '~~/shared/utils/catalogOnly'

/**
 * Tryb katalogowy w warstwie interfejsu.
 *
 * `enabled` jest zwykłym booleanem, nie `computed` — runtime config nie zmienia
 * się w trakcie życia strony, a `v-if="!catalogOnly"` czyta się lepiej niż
 * `v-if="!catalogOnly.value"` w kilkunastu szablonach.
 *
 * Odpowiada wyłącznie za to, CZY pokazać ścieżkę zakupową. Za to, czy da się
 * kupić, odpowiada backend (403) — patrz shared/utils/catalogOnly.ts.
 */
export function useCatalogOnly() {
  const enabled = useRuntimeConfig().public.catalogOnly === true

  return {
    /** Sklep działa jako katalog bez sprzedaży. */
    enabled,
    /** Sprzedaż działa normalnie — wygodniejsze w szablonach niż negacja. */
    sellingEnabled: !enabled,
    /** Etykieta w miejscu przycisku zakupu. */
    ctaLabel: CATALOG_ONLY_CTA_LABEL,
    /**
     * Dokąd prowadzi „Zapytaj o wycenę”.
     *
     * Do czasu wdrożenia modala z formularzem (zadanie T2.1.3) CTA prowadzi na
     * stronę kontaktu z kontekstem produktu w adresie — ścieżka zapasowa
     * przewidziana wprost w opisie tamtego zadania. Kontekst przekazujemy w
     * query, żeby formularz mógł go podjąć bez zmiany tych wywołań.
     */
    quoteHref(idProduct?: number | string | null): string {
      const id = idProduct === null || idProduct === undefined ? '' : String(idProduct)

      return id === '' ? '/contact?temat=wycena' : `/contact?temat=wycena&produkt=${encodeURIComponent(id)}`
    },
  }
}
